var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useState } from 'react';
import t from 'prop-types';
import BotonMuestraGrosor from './boton-muestra-grosor';
import * as HERRAMIENTA from './constantes';
import { is_touch_device } from '../util';
var ON_PRESIONADO = is_touch_device() ? 'onTouchStart' : 'onClick';

function MuestraGrosor(props) {
  var _eventos;

  var _useState = useState(false),
      abierta = _useState[0],
      setAbierta = _useState[1];

  var herramientaId = props.herramientaId,
      grupo = props.grupo,
      valores = props.valores,
      valorSeleccionado = props.valorSeleccionado,
      onPresionado = props.onPresionado,
      onDesplegada = props.onDesplegada;

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setAbierta(!abierta);
  }

  function handlePresionado(id, grupo, valor) {
    setAbierta(false);
    onPresionado(herramientaId, grupo, valor);
  }

  function handleTransitionEnd(e) {
    if (abierta && onDesplegada) {
      onDesplegada(e);
    }
  }

  var id = 'herramienta' + herramientaId;
  var style = {
    backgroundSize: valorSeleccionado
  };
  var clases = 'muestraGrosor' + (abierta ? ' abierta' : '');
  var eventos = (_eventos = {}, _eventos[ON_PRESIONADO] = handleClick, _eventos);
  return React.createElement('div', _extends({
    id: id,
    className: clases,
    style: style
  }, eventos), valorSeleccionado >= 20 && React.createElement('span', {
    className: 'centradoAbsoluto'
  }, valorSeleccionado), React.createElement('div', {
    className: 'barraTerciaria',
    onTransitionEnd: handleTransitionEnd
  }, valores.map(function (valor) {
    return React.createElement(BotonMuestraGrosor, {
      key: id + valor,
      herramientaId: id + '-' + valor,
      grupo: grupo,
      valor: valor,
      presionado: valor === valorSeleccionado,
      onPresionado: handlePresionado
    });
  })));
}

MuestraGrosor.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identificador de la herramienta */
  herramientaId: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton, por defecto: 'Pizarra' */
  grupo: t.string,

  /** array de grosores */
  valores: t.arrayOf(t.number).isRequired,

  /** grosor actualmente seleccionado */
  valorSeleccionado: t.number,

  /** evento que se lanza al seleccionar un grosor: (herramientaId, grupo, valor) => {...} */
  onPresionado: t.func,

  /** evento que se lanza al terminar la animacion de mostrar la barra terciaria */
  onDesplegada: t.func
} : {};
MuestraGrosor.defaultProps = {
  grupo: HERRAMIENTA.GRUPO_PIZARRA,
  activado: false
};
export default MuestraGrosor;